import { useEffect, useMemo, useState } from "react"
import { Modal } from "flowbite-react"
import Loading from "../../../../common/components/ui/loading/Loading"
import { IRepossession } from "@/types/repossession.type"

type Props = {
  repossession: IRepossession
  onClose: () => void
}

export default function ModalViewNotes({ repossession: initialData, onClose }: Props) {
  const [repossession, setRepossession] = useState<IRepossession | null>(null)

  const handleCloseModal = () => onClose()

  useEffect(() => {
    setRepossession(initialData)
  }, [initialData])

  const sortedNotes = useMemo(() => {
    const notes = repossession?.notesDetails ?? []
    return [...notes].sort((a, b) => {
      const aTime = a?.date ? new Date(a.date).getTime() : 0
      const bTime = b?.date ? new Date(b.date).getTime() : 0
      return bTime - aTime
    })
  }, [repossession?.notesDetails])

  return (
    <Modal size='5xl' className='relative' show={true} onClose={handleCloseModal}>
      <Modal.Header className='text-black'>
        <div className="flex items-center justify-start gap-3 text-black">
          <span>{`Observações - ${repossession?.vehicle?.licensePlate || 'Carregando...'}`}</span>
        </div>
      </Modal.Header>

      <Modal.Body
        className='w-full relative border-gray flex flex-col text-black'
        style={{ minHeight: 'calc(50vh - 300px)', height: 'calc(100vh - 300px)' }}
      >
        {repossession ? (
          <div>
            <ul>
              {sortedNotes.map((note, index) => (
                <li key={`${note.date}-${index}`} className="border-b border-gray-200 p-2">
                  <span className="text-gray-500 text-md">
                    {note.date
                      ? new Date(note.date).toLocaleString('pt-BR', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })
                      : 'Data não disponível'}
                  </span>&nbsp;-&nbsp;
                  <span className="text-gray-600 text-md">{note.author}</span>:
                  <br />
                  <span className="text-gray-800 text-md font-semibold">{note.text}</span>
                  <br />
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <Loading />
        )}
      </Modal.Body>
    </Modal>
  )
}
